import { render } from "./SurveyView.vue?vue&type=template&id=e9f81492&ts=true"
import script from "./SurveyView.ts?vue&type=script&lang=ts"
export * from "./SurveyView.ts?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__